import PTORequestWarnings from './PTORequestWarnings.component';

export default PTORequestWarnings;
